import { createSlice } from 'utils/@reduxjs/toolkit';
import { SalesOrganizationState } from './types';
import { reducers } from './reducers';

export const initialState: SalesOrganizationState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'salesOrganization',
  initialState,
  reducers,
});

export const { actions: salesOrganizationActions } = slice;
export const { reducer: salesOrganizationReducer } = slice;
